/**
 * The main api service
 */
import http from '@util/http';
import { common } from '@api/req';

export async function queryBusinessInfo(params) {
  return http.get(common.BUSINESS_INFO, params).then(res => {
    if (res.statusCode === 200) {
      return http.get(res.data.url, {});
    }
  });
}

export async function queryBusinessLog(params) {
  return http.get(common.BUSINESS_LOG, params);
}



// WEBPACK FOOTER //
// ./src/api/common/business.js